import CollectionDetailModalComponent from "./CollectionDetailModalComponent";

export default CollectionDetailModalComponent;